//SOURCE: DYNAMIC FORM VALIDATION WITH REACT BY NWAKAEME CYNTHIA - https://stackblitz.com/edit/stackblitz-starters-arhkmg
import TEXT from "./atom/TEXT";
import DATE from "./atom/DATE";
import FILE from "./atom/FILE";
import EMAIL from "./atom/EMAIL";
import RADIO from "./atom/RADIO";
import NUMBER from "./atom/NUMBER";
import SELECT from "./atom/SELECT";
import CHECKBOX from "./atom/CHECKBOX";
import { InputType } from "../../utils/helpers/constants";
import ADDRESS from "./atom/ADDRESS";


const DynamicFields = ({ divClass, inputClass, formControl, formHook, initialValue, showHelp = false, helpText = "" }) => {

  switch (true) {
    case formControl.type === InputType.TEXT &&
         formControl.key === "house_address":
      return ADDRESS({
        divClass,
        inputClass,
        formControl,
        formHook,
        initialValue: initialValue && initialValue[formControl.key],
        showHelp,
        helpText,
      });
    case formControl.type === InputType.TEXT:
      return TEXT({ divClass, inputClass, formControl, formHook, initialValue: initialValue && initialValue[formControl["key"]], showHelp, helpText });
    case formControl.type === InputType.EMAIL:
      return EMAIL({ divClass, inputClass, formControl, formHook, initialValue: initialValue && initialValue[formControl["key"]], showHelp, helpText });
    case formControl.type === InputType.NUMBER:
      return NUMBER({ divClass, inputClass, formControl, formHook, initialValue: initialValue && initialValue[formControl["key"]], showHelp, helpText });
    case formControl.type === InputType.BOOLEAN:
      return CHECKBOX({ divClass, formControl, formHook, initialValue: initialValue && initialValue[formControl["key"]] });
    case formControl.type === InputType.RADIO:
      return RADIO({ divClass, formControl, formHook, initialValue: initialValue && initialValue[formControl["key"]] });
    case formControl.type === InputType.OPTIONS:
      return SELECT({ divClass, formControl, formHook, initialValue: initialValue && initialValue[formControl["key"]], showHelp, helpText });
    case formControl.type === InputType.DATE:
      return DATE({ divClass, formControl, formHook, initialValue: initialValue && initialValue[formControl["key"]], showHelp, helpText });
    case formControl.type === InputType.FILE:
      return FILE({ divClass, inputClass, formControl, formHook, showHelp, helpText });

    default:
      return null
  }
}
export default DynamicFields;
